export default {
  configuracoes: {},
  notificacoes: [],
  filtro: '',
};
